export default __webpack_public_path__ + "static/media/text0.1890dd50.glb";